import { Trophy, CalendarDays, Ticket, Users, Settings2 } from "lucide-react";

const TABS = [
  { key: "ladder", label: "Ladder", icon: Trophy },
  { key: "races", label: "Races", icon: CalendarDays },
  { key: "my-picks", label: "My Picks", icon: Ticket },
  { key: "all-picks", label: "All Picks", icon: Users },
  { key: "admin", label: "Admin", icon: Settings2 },
];

export default function BottomNav({ active, onChange }) {
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-[#e9ecef]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav"
    >
      <div className="max-w-[480px] mx-auto h-20 flex items-stretch">
        {TABS.map((t) => {
          const Icon = t.icon;
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              onClick={() => onChange(t.key)}
              className="relative flex-1 flex flex-col items-center justify-center gap-1 active:scale-95 transition-transform"
              data-testid={`bottom-nav-${t.key}`}
              aria-current={isActive ? "page" : undefined}
            >
              {isActive && (
                <span
                  className="absolute top-0 left-1/2 -translate-x-1/2 h-1 w-8 rounded-b-full"
                  style={{ backgroundColor: "#1971c2" }}
                />
              )}
              <Icon
                className="w-6 h-6"
                strokeWidth={2.5}
                style={{ color: isActive ? "#1971c2" : "#6c757d" }}
              />
              <span
                className="text-[11px] font-bold"
                style={{ color: isActive ? "#1971c2" : "#6c757d" }}
              >
                {t.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
